<template>
  <Layout>
    <template v-slot:title>Contraseña Olvidada</template>
    <div class="mt-20 mx-4">
      <BaseAlert v-if="showAlert" class="alert-success mb-8">
        Hemos recibido correctamente tu solicitud y te hemos hemos enviado un
        correo con las indicaciones necesarias. Por favor, revisa tu carpeta
        SPAM, por si el correo se hubiera almacenado allí
      </BaseAlert>

      <p class="my-8">
        Por favor, introduce tu email para que te enviemos el enlace para
        restaurar tu contraseña:
      </p>
      <form
        class="max-w-sm mx-auto mt-16"
        novalidate
        @submit.prevent="sendData"
      >
        <BaseInputText
          ref="email"
          type="email"
          label="Email"
          name="email"
          class="mb-4"
          :value="email"
          :v="$v.email"
          @input="updateEmail"
          @blur="$v.email.$touch()"
        />

        <LoadingButton class="mt-2" :loading="sendingData">
          Enviar
        </LoadingButton>
      </form>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import updateFieldMixin from '@/mixins/updateFieldMixin'
import Layout from '@/layouts/MainLayout'
import LoadingButton from '@/components/LoadingButton'

export default {
  components: { Layout, LoadingButton },
  mixins: [validationMixin, updateFieldMixin],

  computed: {
    ...mapState('forms', ['sendingData']),
    ...mapState('auth', ['email', 'showAlert']),
  },

  mounted() {
    this.$refs.email.$el.querySelector('input').focus()
    this.$store.commit('auth/showAlert', false)
  },

  methods: {
    updateEmail(e) {
      this.$store.commit('auth/showAlert', false)
      this.updateField(e, 'auth/updateEmail', 'email')
    },

    sendData() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const payload = {
          email: this.email,
        }
        this.$store.dispatch('auth/forgottenPassword', payload)
        this.$v.$reset()
      }
    },
  },

  validations: {
    email: { required, email },
  },
}
</script>
